// extracted by mini-css-extract-plugin
module.exports = {"defaultSportIcon":"SportIcon_defaultSportIcon__N3RI7","active":"SportIcon_active__UY6Pz"};